/**
 * Хэш состояния боя для `WaveResult.stateHash`: два 32-битных потока (FNV-1a по словам и murmur-подобный),
 * итог — 16 hex-символов. Функцию не менять без `WAVE_LOG_FORMAT + 1` (contracts/wave-log).
 */
export class StateHasher {
  private h1 = 0x811c9dc5;
  private h2 = 0x9747b28c;

  /** Добавить целое (любой знак, |n| < 2^53). */
  int(n: number): this {
    const lo = n | 0;
    const hi = Math.floor(n / 4294967296) | 0;
    this.word(lo);
    if (hi !== 0 && hi !== -1) this.word(hi);
    return this;
  }

  bool(b: boolean): this {
    return this.int(b ? 1 : 0);
  }

  str(s: string): this {
    this.int(s.length);
    for (let i = 0; i < s.length; i++) this.word(s.charCodeAt(i));
    return this;
  }

  hex(): string {
    return (this.h1 >>> 0).toString(16).padStart(8, "0") + (this.h2 >>> 0).toString(16).padStart(8, "0");
  }

  private word(w: number): void {
    this.h1 = Math.imul(this.h1 ^ w, 0x01000193);
    let k = Math.imul(w, 0x5bd1e995);
    k ^= k >>> 24;
    k = Math.imul(k, 0x5bd1e995);
    this.h2 = Math.imul(this.h2, 0x5bd1e995) ^ k;
    this.h2 ^= this.h2 >>> 13;
  }
}
